import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-attack-simulations',
  templateUrl: './attack-simulations.component.html',
  styleUrl: './attack-simulations.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttackSimulationsComponent {}
